const routes = [
    {
        name: 'home',
        path: '/',
        component: () => import('../components/home/home.vue'),
    },
    {
        name: 'message',
        path: '/message',
        component: () => import('../components/message/message.vue'),
    },
    {
        name: 'messageDetail',
        path: '/messageDetail',
        component: () => import('../components/message/messageDetail.vue'),
    },
    {
        name: 'login',
        path: '/login',
        component: () => import('../components/loginSign/login'),
    },
    {
        name: 'sign',
        path: '/sign',
        component: () => import('../components/loginSign/sign'),
    },
    {
        name: 'promo',
        path: '/promo',
        component: () => import('../components/promo/promo'),
    },
    {
        name: 'promoDetail',
        path: '/promoDetail',
        component: () => import('../components/promo/promoDetail'),
    },
    {
        name: 'service',
        path: '/service',
        component: () => import('../components/service/service'),
    },
    {
        name: 'setting',
        path: '/setting',
        component: () => import('../components/setting/setting'),
    },
    {
        name: 'modifyGetPhoneValidCode',
        path: '/modifyGetPhoneValidCode',
        component: () => import('../components/setting/modifyGetPhoneValidCode'),
    },
    {
        name: 'modifyPWD',
        path: '/modifyPWD',
        component: () => import('../components/setting/modifyPWD'),
    },
    {
        name: 'resetPWD',
        path: '/resetPWD',
        component: () => import('../components/personal/resetPWD'),
    },
    {
        name: 'mine',
        path: '/mine',
        component: () => import('../components/mine/mine'),
    },
    {
        name: 'selfService',
        path: '/selfService',
        component: () => import('../components/selfService/selfService'),
    },
    {
        name: 'transactionLog',
        path: '/transactionLog',
        component: () => import('../components/log/transactionLog'),
    },
    {
        name: 'integralMarket',
        path: '/integralMarket',
        component: () => import('../components/integralMarket/integralMarket'),
    },
    {
        name: 'specialPromo',
        path: '/specialPromo',
        component: () => import('../components/specialPromo/specialPromo'),
    },
    {
        name: 'comment',
        path: '/comment',
        component: () => import('../components/comment/comment'),
    },
    {
        name: 'agentJoin',
        path: '/agentJoin',
        component: () => import('../components/agentJoin/agentJoin'),
    },
    {
        name: 'agent',
        path: '/agent',
        component: () => import('../components/agent/agent'),
    },
    {
        name: 'betLog',
        path: '/betLog',
        component: () => import('../components/log/betLog'),
    },
    {
        name: 'accountSetting',
        path: '/accountSetting',
        component: () => import('../components/accountSetting/accountSetting'),
    },
    {
        name: 'addCard',
        path: '/addCard',
        component: () => import('../components/accountSetting/addCard'),
    },
    {
        name: 'vip',
        path: '/vip',
        component: () => import('../components/vip/vip'),
    },
    {
        name: 'vipDetail',
        path: '/vipDetail',
        component: () => import('../components/vip/vipDetail'),
    },
    {
        name: 'live',
        path: '/live',
        component: () => import('../components/game/live'),
    },
    {
        name: 'liveList',
        path: '/liveList',
        component: () => import('../components/game/liveList'),
    },
    {
        name: 'slot',
        path: '/slot',
        component: () => import('../components/game/slot'),
    },
    {
        name: 'game',
        path: '/game',
        component: () => import('../components/game/game'),
    },
    {
        name: 'personal',
        path: '/personal',
        component: () => import('../components/personal/personal'),
    },
    {
        name: 'restorePWD',
        path: '/restorePWD',
        component: () => import('../components/personal/restorePWD'),
    },
    {
        name: 'findByPhone',
        path: '/findByPhone',
        component: () => import('../components/personal/findByPhone'),
    },
    {
        name: 'findByPhoneGetValidCode',
        path: '/findByPhoneGetValidCode',
        component: () => import('../components/personal/findByPhoneGetValidCode'),
    },
    {
        name: 'findByEmail',
        path: '/findByEmail',
        component: () => import('../components/personal/findByEmail'),
    },
    {
        name: 'findByEmailGetValidCode',
        path: '/findByEmailGetValidCode',
        component: () => import('../components/personal/findByEmailGetValidCode'),
    },
    {
        name: 'setPayPWD',
        path: '/setPayPWD',
        component: () => import('../components/personal/setPayPWD'),
    },
    {
        name: 'resetPayPWD',
        path: '/resetPayPWD',
        component: () => import('../components/personal/resetPayPWD'),
    },
    {
        name: 'setNickName',
        path: '/setNickName',
        component: () => import('../components/personal/setNickName'),
    },
    {
        name: 'deposit',
        path: '/deposit',
        component: () => import('../components/deposit/deposit'),
    },
    {
        name: 'withdraw',
        path: '/withdraw',
        component: () => import('../components/withdraw/withdraw'),
    },
    {
        name: 'setGender',
        path: '/setGender',
        component: () => import('../components/personal/setGender'),
    },
    {
        name: 'setBirth',
        path: '/setBirth',
        component: () => import('../components/personal/setBirth'),
    },
    {
        name: 'setPhone',
        path: '/setPhone',
        component: () => import('../components/personal/setPhone'),
    },
    {
        name: 'setPhoneGetValidCode',
        path: '/setPhoneGetValidCode',
        component: () => import('../components/personal/setPhoneGetValidCode'),
    },
    {
        name: 'setEmail',
        path: '/setEmail',
        component: () => import('../components/personal/setEmail'),
    },
    {
        name: 'setEmailGetValidCode',
        path: '/setEmailGetValidCode',
        component: () => import('../components/personal/setEmailGetValidCode'),
    },
    {
        name: 'hot',
        path: '/hot',
        component: () => import('../components/game/hot'),
    },
    {
        name: 'sports',
        path: '/sports',
        component: () => import('../components/game/sports'),
    },
    {
        name: 'sportList',
        path: '/sportList',
        component: () => import('../components/game/sportList'),
    },
    {
        name: 'chess',
        path: '/chess',
        component: () => import('../components/game/chess'),
    },
    {
        name: 'lottery',
        path: '/lottery',
        component: () => import('../components/game/lottery'),
    },
    {
        name: 'fish',
        path: '/fish',
        component: () => import('../components/game/fish'),
    },
    {
        name: 'slot',
        path: '/slot',
        component: () => import('../components/game/slot'),
    },
    {
        name: 'protocol',
        path: '/protocol',
        component: () => import('../components/protocol/protocol'),
    },
    {
        name: 'registerProtocol',
        path: '/registerProtocol',
        component: () => import('../components/loginSign/registerProtocol'),
    },
    {
        name: 'relatedAgreement',
        path: '/relatedAgreement',
        component: () => import('../components/loginSign/relatedAgreement'),
    },
    {
        name: 'privateProtocol',
        path: '/privateProtocol',
        component: () => import('../components/loginSign/privateProtocol'),
    }
]

export default routes
